class SSNValidator {
  static luhnAlgorithm (val) {
    var ssn = val
    .replace(/\D/g, '')
    .split('')
    .reverse()
    .slice(0, 10);

    if (ssn.length !== 10) {
      return false;
    }

    var sum = ssn
    .map(function (n) {
      return Number(n);
    })
    .reduce(function (previous, current, index) {
      if (index % 2) current *= 2;
      if (current > 9) current -= 9;
      return previous + current;
    });
    return sum % 10 === 0;
  }

  static cleanSSN (value) {
    const patternSSN = /^\d{6}(\d{2})?[-]?\d{4}$/;

    if (!patternSSN.test(value)) {
      return null;
    }

    if (typeof (value) === 'number' && value !== undefined) {
      value = value.toString();
    } else if (typeof (value) !== 'string' && typeof (value) !== 'number' || value === undefined) {
      return null;
    }
    value = value.replace(/\D/g, '');

    switch (value.length) {
      case 10:
        return value;
      case 12:
        return value.substring(2);
      default:
        return null;
    }
  }

  static splitSSN (value) {
    return value.match(/.{1,2}/g);
  }

  static validateSSN (ssn) {
    ssn = this.cleanSSN(ssn);
    if (!ssn) {
      return null;
    }

    var splitSSn = this.splitSSN(ssn);
    if (splitSSn[2] > 31 && splitSSn[2] < 60) {
      return null;
    }

    if (splitSSn[1] > 12) {
      return null;
    }

    if (!this.luhnAlgorithm(ssn)) {
      return null;
    }
    return ssn;
  }
}

export default SSNValidator;



/** WEBPACK FOOTER **
 ** ./src/validators/ssnvalidator.js
 **/